var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Vault Settings")]),_c('OverwriteExistingYN',{model:{value:(_vm.form.data.settings.update_existing_items),callback:function ($$v) {_vm.$set(_vm.form.data.settings, "update_existing_items", $$v)},expression:"form.data.settings.update_existing_items"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }